import { IAssociationsStates, InitialGeneralState } from 'interfaces/general.interface';
import * as GeneralTypes from './general.types';
import {
  ICountryAPIResponseItem,
  IGetExchangesAPIResponseItem,
  IGetPointsOfSaleCategoriesAPIResponseItem,
} from 'api/endpoints/general/general.response.interface';

export type TgeneralDispatchReducer =
  | {
      type: typeof GeneralTypes.SET_PING;
      payload: boolean;
    }
  | {
      type: typeof GeneralTypes.SET_EXCHANGES;
      payload: Array<IGetExchangesAPIResponseItem>;
    }
  | {
      type: typeof GeneralTypes.SET_COUNTRIES;
      payload: Array<ICountryAPIResponseItem>;
    }
  | {
      type: typeof GeneralTypes.SET_ASSOCIATIONS_STATES;
      payload: IAssociationsStates;
    }
  | {
      type: typeof GeneralTypes.SET_POINTS_OF_SALE_CATEGORIES;
      payload: Array<IGetPointsOfSaleCategoriesAPIResponseItem>;
    }
  | {
      type: typeof GeneralTypes.SET_IS_LOADING_POINTS_OF_SALE_CATEGORIES;
      payload: boolean;
    }
  | {
      type: typeof GeneralTypes.SET_CATEGORY_SELECTED;
      payload: IGetPointsOfSaleCategoriesAPIResponseItem | null;
    }
  | {
      type: typeof GeneralTypes.CREATE_CATEGORY;
      payload: IGetPointsOfSaleCategoriesAPIResponseItem;
    }
  | {
      type: typeof GeneralTypes.IS_LOADING_CREATE_CATEGORY;
      payload: boolean;
    }
  | {
      type: typeof GeneralTypes.UPDATE_CATEGORY;
      payload: IGetPointsOfSaleCategoriesAPIResponseItem;
    }
  | {
      type: typeof GeneralTypes.IS_LOADING_UPDATE_CATEGORY;
      payload: boolean;
    }
  | {
      type: typeof GeneralTypes.DELETE_CATEGORY;
      payload: string;
    }
  | {
      type: typeof GeneralTypes.IS_LOADING_DELETE_CATEGORY;
      payload: {
        categoryId: string;
        isLoading: boolean;
      };
    };

export default function generalReducer(
  state: InitialGeneralState,
  action: TgeneralDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case GeneralTypes.SET_PING: {
      const setPing: InitialGeneralState = {
        ...state,
        ping: payload,
        isLoadingSetPing: false,
      };
      return setPing;
    }

    case GeneralTypes.SET_EXCHANGES: {
      const setExchanges: InitialGeneralState = {
        ...state,
        exchanges: payload,
      };
      return setExchanges;
    }

    case GeneralTypes.SET_COUNTRIES:
      const setCountries: InitialGeneralState = {
        ...state,
        countries: payload,
      };
      return setCountries;

    case GeneralTypes.SET_ASSOCIATIONS_STATES: {
      const setAssociationsStates: InitialGeneralState = {
        ...state,
        associationStates: payload,
      };
      return setAssociationsStates;
    }

    // Points of Sale Categories ////////////////////////////////////
    case GeneralTypes.SET_POINTS_OF_SALE_CATEGORIES: {
      const setPointsOfSaleCategories: InitialGeneralState = {
        ...state,
        pointsOfSaleCategories: payload,
      };
      return setPointsOfSaleCategories;
    }

    case GeneralTypes.SET_IS_LOADING_POINTS_OF_SALE_CATEGORIES: {
      const setIsLoadingPointsOfSaleCategories: InitialGeneralState = {
        ...state,
        isLoadingPointsOfSaleCategories: payload,
      };
      return setIsLoadingPointsOfSaleCategories;
    }

    case GeneralTypes.SET_CATEGORY_SELECTED: {
      const setCategorySelected: InitialGeneralState = {
        ...state,
        categorySelected: payload,
      };
      return setCategorySelected;
    }

    case GeneralTypes.CREATE_CATEGORY: {
      const createCategory: InitialGeneralState = {
        ...state,
        pointsOfSaleCategories: [payload, ...state.pointsOfSaleCategories],
      };
      return createCategory;
    }

    case GeneralTypes.IS_LOADING_CREATE_CATEGORY: {
      const isLoadingCreateCategory: InitialGeneralState = {
        ...state,
        isLoadingCreateCategory: payload,
      };
      return isLoadingCreateCategory;
    }

    case GeneralTypes.UPDATE_CATEGORY: {
      const updatedCategories = state.pointsOfSaleCategories.map((category) =>
        category.id === payload.id ? payload : category
      );
      const updateCategory: InitialGeneralState = {
        ...state,
        pointsOfSaleCategories: updatedCategories,
      };
      return updateCategory;
    }

    case GeneralTypes.IS_LOADING_UPDATE_CATEGORY: {
      const isLoadingUpdateCategory: InitialGeneralState = {
        ...state,
        isLoadingUpdateCategory: payload,
      };
      return isLoadingUpdateCategory;
    }

    case GeneralTypes.DELETE_CATEGORY: {
      const updatedCategories = state.pointsOfSaleCategories.filter(
        (category) => category.id !== payload
      );
      const deleteCategory: InitialGeneralState = {
        ...state,
        pointsOfSaleCategories: updatedCategories,
      };
      return deleteCategory;
    }

    case GeneralTypes.IS_LOADING_DELETE_CATEGORY: {
      const isLoadingDeleteCategory: InitialGeneralState = {
        ...state,
        isLoadingDeleteCategory: {
          categoryId: payload.categoryId,
          isLoading: payload.isLoading,
        },
      };
      return isLoadingDeleteCategory;
    }
    /////////////////////////////////////////////////////////////////

    default:
      return state;
  }
}
